import { REACT_APP_API_URL } from '@/helpers/conf';
import { PUBLIC_URL } from '@/helpers/constants';

export const REVALIDATE =
  process.env.NEXT_PUBLIC_APP_ENV === 'development' ? 0 : 30 * 60; // 30 minutes

export const CLIENT_BASE_URL = `${process.env.NEXT_PUBLIC_APP_ENV === 'development' ? '' : REACT_APP_API_URL}/api`;
export const SERVER_BASE_URL = `${PUBLIC_URL}/api`;
